import React from "react";
import { NavLink } from "react-router-dom";
import { FaYoutube, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa6";
import { RiTwitterXLine } from "react-icons/ri";
import { PiThreadsLogo } from "react-icons/pi";

export default function Footer() {
  return (
    <>
      {/* Desktop and larger */}
      <div className="hidden md:flex w-full bg-[#0f0c29] py-6 border-t border-white/10">
        <div className="w-[92%] mx-auto grid grid-cols-3 gap-8 items-start text-[13px] text-gray-300">
          {/* Column 1: Copyright */}
          <div>
            <p className="leading-5">GOATHLETE GLOBAL SPORTS PRIVATE LIMITED<br/>© 2025 All rights reserved</p>
          </div>

          {/* Column 2: Quick Access arranged */}
          <div className="flex flex-col items-center">
            <span className="text-gray-400">Quick Access</span>
            <div className="mt-2 grid grid-cols-2 gap-x-8 gap-y-2">
              <NavLink to="/start-playing" className="hover:text-white">Start Playing</NavLink>
              <NavLink to="/get-trained" className="hover:text-white">Get Trained</NavLink>
              <NavLink to="/where-to-play" className="hover:text-white">Where to Play</NavLink>
              <NavLink to="/shop-sports-gear" className="hover:text-white">Shop</NavLink>
              <NavLink to="/events" className="hover:text-white">Events</NavLink>
              <NavLink to="/contact" className="hover:text-white">Contact</NavLink>
            </div>
          </div>

          {/* Column 3: Legal + Social */}
          <div className="flex flex-col items-end gap-3">
            <div className="flex items-center gap-4">
              <NavLink to="/company" className="hover:text-white">Company</NavLink>
              <NavLink to="/about" className="hover:text-white">About</NavLink>
              <NavLink to="/privacy-policy" className="hover:text-white">Privacy</NavLink>
              <NavLink to="/terms-and-conditions" className="hover:text-white">Terms</NavLink>
            </div>
            <div className="flex items-center gap-3 text-gray-300 text-[18px]">
              <a href="https://www.youtube.com/@GoathleteGlobalSports" aria-label="YouTube" className="hover:text-white"><FaYoutube /></a>
              <a href="https://www.facebook.com/people/GoAthlete-global-sports-private-limited/61576088394649/#" aria-label="Facebook" className="hover:text-white"><FaFacebook /></a>
              <a href="https://www.instagram.com/_goathlete_/" aria-label="Instagram" className="hover:text-white"><FaInstagram /></a>
÷              <a href="https://x.com/GoathleteGlobal" aria-label="X" className="hover:text-white"><RiTwitterXLine /></a>
              <a href="https://www.linkedin.com/company/goathlete-globalsports-private-limited/" aria-label="LinkedIn" className="hover:text-white"><FaLinkedin /></a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="flex md:hidden w-full bg-[#0f0c29] px-4 py-5 flex-col items-center text-center gap-3 border-t border-white/10">
        <p className="text-gray-300 text-[12px] font-[500] leading-5">
          GOATHLETE GLOBAL SPORTS PRIVATE LIMITED -2025 All rights reserved
        </p>
        <div className="grid grid-cols-3 gap-3 text-[12px] text-gray-300 font-[500] justify-items-center w-full max-w-md">
          <NavLink to="/start-playing">Start Playing</NavLink>
          <NavLink to="/get-trained">Get Trained</NavLink>
          <NavLink to="/where-to-play">Where to Play</NavLink>
          <NavLink to="/shop-sports-gear">Shop</NavLink>
          <NavLink to="/events">Events</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </div>
        <div className="flex flex-wrap gap-5 text-gray-300 text-[18px] justify-center">
          <a href="#" aria-label="YouTube"><FaYoutube /></a>
          <a href="#" aria-label="Facebook"><FaFacebook /></a>
          <a href="#" aria-label="Instagram"><FaInstagram /></a>
          <a href="#" aria-label="Threads"><PiThreadsLogo /></a>
          <a href="#" aria-label="X"><RiTwitterXLine /></a>
          <a href="#" aria-label="LinkedIn"><FaLinkedin /></a>
        </div>
        <div className="flex flex-wrap gap-x-4 gap-y-2 text-[12px] text-gray-300 font-[500] justify-center">
          <NavLink to="/company">Company</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/privacy-policy">Privacy</NavLink>
          <NavLink to="/terms-and-conditions">Terms</NavLink>
        </div>
      </div>
    </>
  );
}
